// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Ризики» (Risks, ключ `rsk`, група `management`). */
export const risksManifest: IModuleManifest = {
  key: 'rsk',
  group: 'management',
  slug: 'risks',
  prefix: 'RSK',
  name: { en: 'Risks', uk: 'Ризики' },
  entities: [
    { key: 'rsk', slug: 'rsk', name: { en: 'Risks', uk: 'Ризики' }, main: true },
    { key: 'risk_mitigation', slug: 'risk-mitigation', name: { en: 'Risk Mitigations', uk: 'Заходи зі зниження ризику' }, main: false },
    { key: 'risk_project', slug: 'risk-project', name: { en: 'Risk Projects', uk: 'Проєкти' }, main: false },
    { key: 'risk_assessment', slug: 'risk-assessment', name: { en: 'Risk Assessments', uk: 'Оцінки ризику' }, main: false },
  ],
  loadState: () => import('./state/risksSlice').then((m) => m.risksSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
  loadViews: () => import('./views').then((m) => m.views),
};
